import { Provider } from 'react-redux'
import { ThemeProvider } from 'styled-components'
import { store } from './store'

import GlobalStyle from './styles/GlobalStyle'
import theme from './styles/theme'
import AppContent from './AppContent'

function App() {
  return (
    <div className='App'>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          <AppContent />
        </ThemeProvider>
      </Provider>
    </div>
  )
}

export default App
